import { useFetchEffect } from '@lucidhq/lucidium';
import { useAuth } from "../hooks";
import { adjustOptions } from './prepareFetch';
export function useAuthFetchEffect(endpoint, options, skip) {
    if (options === void 0) { options = {}; }
    if (skip === void 0) { skip = false; }
    var auth = useAuth();
    return useFetchEffect(endpoint, adjustOptions(auth, options), skip);
}
//# sourceMappingURL=useAuthFetchEffect.js.map